import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { BN, web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { State } from '@switchboard-xyz/on-demand';

const LUT_PID = new web3.PublicKey(
  'AddressLookupTab1e1111111111111111111111111'
);

function deriveLookupTableAddress(
  programId: web3.PublicKey,
  authorityAddress: web3.PublicKey,
  recentBlockSlot: BN
): [web3.PublicKey, number] {
  // Convert slot number (BN) to Little Endian byte array (8 bytes)
  const slotBuffer = recentBlockSlot.toArrayLike(Buffer, 'le', 8);

  // Find Program Derived Address (PDA)
  return web3.PublicKey.findProgramAddressSync(
    [authorityAddress.toBuffer(), slotBuffer],
    programId
  );
}

export default class QueueResetLut extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Reset lut of queue account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    queue: Flags.string({
      description: 'public key of the queue account',
      required: true,
    }),
  };

  static args = {};

  async run() {
    const { flags } = await this.parse(
      this.constructor as typeof QueueResetLut
    );

    const program = await this.program;

    const stateKey = State.keyFromSeed(program);
    const queue = new web3.PublicKey(flags.queue);
    const lutSigner = (
      await web3.PublicKey.findProgramAddress(
        [Buffer.from('LutSigner'), queue.toBuffer()],
        program.programId
      )
    )[0];

    const recentSlot = await this.connection.getSlot('finalized');
    const [lut] = deriveLookupTableAddress(
      LUT_PID,
      lutSigner,
      new BN(recentSlot)
    );

    console.log(
      `# creating lut ${lut} with signer ${lutSigner}  with slot ${recentSlot}`
    );
    const ix = program.instruction.queueResetLut(
      {
        recentSlot: new BN(recentSlot.toString()),
      },
      {
        accounts: {
          queue: queue,
          authority: this.keypair.publicKey,
          payer: this.keypair.publicKey,
          systemProgram: web3.SystemProgram.programId,
          programState: stateKey,
          lutSigner,
          lut,
          addressLookupTableProgram: web3.AddressLookupTableProgram.programId,
        },
      }
    );

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, '# QUEUE - failed sync lut tx');
  }
}
